export default __webpack_public_path__ + "static/media/957.bb1c1d95.gif";